// extracted by mini-css-extract-plugin
export default {"screen":"Audio_screen__Mfbe9","logo":"Audio_logo__0R57b","body":"Audio_body__dDEAB","headerBox":"Audio_headerBox__jpga5"};